import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

// Database types
export interface Database {
  public: {
    Tables: {
      time_entries: {
        Row: {
          id: number;
          date: string;
          shifts: any; // JSON array of shifts
          total_hours: number;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: number;
          date: string;
          shifts: any;
          total_hours: number;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: number;
          date?: string;
          shifts?: any;
          total_hours?: number;
          created_at?: string;
          updated_at?: string;
        };
      };
      monthly_rates: {
        Row: {
          id: number;
          year: number;
          month: number;
          hourly_rate: number;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: number;
          year: number;
          month: number;
          hourly_rate: number;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: number;
          year?: number;
          month?: number;
          hourly_rate?: number;
          created_at?: string;
          updated_at?: string;
        };
      };
    };
  };
}
